import axios from 'axios'
import router from '../src/router'
import {Toast} from "vant";
// import { Message, Loading } from 'element-ui'
const ConfigBaseURL = process.env.VUE_APP_BASE_API //默认路径，这里也可以使用env来判断环境
// const ConfigBaseURL = '/api'
// let loadingInstance = null //这里是loading
//使用create方法创建axios实例
export const Service = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
export const ServiceGet = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: 'get',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
export const ServiceWxGet = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: 'get',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
// 添加请求拦截器
// Service.interceptors.request.use(config => {
//   loadingInstance = Loading.service({
//     lock: true,
//     text: 'loading...'
//   })
//   return config
// })
// 添加axios响应拦截器
ServiceGet.interceptors.response.use(response => {
  console.log('response:',response.data.code,response)
  if(response.data.code == 1001){
    Toast('未登陆')
    router.push('/ShopLogin');
  }
  return response
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Message({
    message: '网络错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
})

Service.interceptors.response.use(response => {
  console.log('response:',response.data.code,response)
  if(response.data.code == 1001){
    // console.log(response.data.msg)
    Toast('未登陆')
    router.push('/ShopLogin');
  }
  return response
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Message({
    message: '网络错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
})

ServiceWxGet.interceptors.response.use(response => {
  console.log('response:',response.data.code,response)
  if(response.data.code == 1001){
    Toast('未登陆')
    router.push('/ShopLogin');
  }
  return response
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Message({
    message: '网络错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
})